import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { IssuingState, IssuingStore } from './issuing.store';

@Injectable({ providedIn: 'root' })
export class IssuingQuery extends QueryEntity<IssuingState> {
  constructor(protected store: IssuingStore) {
    super(store);
  }
}
